import React, { useEffect, useState } from "react";
import { createWebComponentWrapper } from "../utils/webComponentWrapper.ts";
import Cookies from "js-cookie";

const RptSystemCompatibilityWebComponent = createWebComponentWrapper("rpt-system-compatibility");

interface SystemCompatibilityComponentProps {
  proctoringType?: "live" | "lite";
  locationType?: "on" | "off";
  onSuccess?: () => void;
}
const SystemCompatibilityComponent: React.FC<SystemCompatibilityComponentProps> = ({
  proctoringType = "lite",
  locationType = "on",
  onSuccess,
}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState<string | null>(null);

  // The WebRTC/system-compatibility web component no longer reads these from the
  // session itself — the exam platform (here) owns the session and hands them in.
  const token = sessionStorage.getItem("loginSessionId") || "";
  useEffect(() => {
    let attempts = 0;
    const maxAttempts = 50;

    const checkElement = () => {
      attempts++;

      if (!window.customElements) {
        setError("Custom Elements are not supported in this browser.");
        return;
      }

      if (window.customElements.get("rpt-system-compatibility")) {
        setIsLoaded(true);
      } else if (attempts >= maxAttempts) {
        setError("Failed to load Angular component.");
      } else {
        setTimeout(checkElement, 100);
      }
    };

    setTimeout(checkElement, 100);
  }, []);

  useEffect(() => {
    const handler = () => {
      const activeProject = Cookies.get("test_engine_project");
      sessionStorage.setItem("systemCompatibilityReturnUrl", window.location.href);
      window.location.href = `/${activeProject}/screen-share-instructions`;
    };
    document?.addEventListener('addExtensionClick', handler);
    return () => document?.removeEventListener('addExtensionClick', handler);
  }, []);

  const handleCustomEvent = (event: any) => {
    if (
      event.type === "continueBtnClick" ||
      event.detail?.type === "continueBtnClick"
    ) {
      onSuccess?.();
    }
  };

  if (error) {
    return (
      <div style={{ padding: 20 }}>
        <h3>Error Loading Component</h3>
        <p>{error}</p>
      </div>
    );
  }

  if (!isLoaded) {
    return (
      <div className="loading-container">
        <h3>Loading Application...</h3>
        <div className="loading-spinner"></div>
      </div>
    );
  }

  return (
    <RptSystemCompatibilityWebComponent
      data-testid="rpt-system-compatibility"
      className="angular-web-component"
      style={{
        width: "100%",
        minHeight: "450px",
        display: "block",
      }}
      role="application"
      aria-label="System Compatibility Test"
      proctoring-type={proctoringType}
      location-type={locationType}
      token={token}
      onContinueBtnClick={handleCustomEvent}
    />
  );
};

export default SystemCompatibilityComponent;